import { useEffect } from 'react';
import { initAllIntegrations } from '@/config/integrations';

const Analytics = () => {
  useEffect(() => {
    // Инициализируем все активные интеграции
    initAllIntegrations();

    return () => {
      // Очистка при размонтировании компонента
      const scripts = document.querySelectorAll('script[src*="googletagmanager"], script[src*="yandex"], script[src*="facebook"]');
      scripts.forEach(script => script.remove());
    };
  }, []);

  return null; // Компонент не рендерит ничего визуального
};

export default Analytics;